import { ReactNode } from 'react'
import * as Yup from 'yup'
import { TFunction } from 'react-i18next'
import { MultiStepFormFieldType as FieldType, Tooltip } from '@percent/lemonade'
import { passwordRequirementRegExp } from '@percent/cause-dashboard/common/utility/validation'
import { config } from '@percent/cause-dashboard/config'
import styles from './OneStepSignUp.module.scss'

export const passwordAndConsentSchemas = (t: TFunction) => ({
  password: Yup.string()
    .min(8, t('form.minLength', { name: 'Password', length: 8 }))
    .max(64, t('form.maxLength', { name: 'Password', length: 64 }))
    .matches(passwordRequirementRegExp, t('errorMessage.passwordRequirement'))
    .required(t('form.isRequired', { name: 'Password' })),
  agreement: Yup.boolean().oneOf([true], t('errorMessage.acceptTerms')).required(t('errorMessage.acceptTerms')),
  marketingConsent: Yup.boolean().optional()
})

export const passwordField = (t: TFunction, description?: string) => ({
  name: 'password',
  label: t('form.password'),
  placeholder: t('form.createAPassword'),
  type: 'password' as FieldType,
  description
})

export const termsLinks = (t: TFunction) => ({
  terms: (
    <a target="_blank" rel="noreferrer" href={config.urls.terms}>
      {t('typography.termsOfService')}
    </a>
  ),
  privacyPolicy: (
    <a target="_blank" rel="noreferrer" href={config.urls.privacyAndPolicy}>
      {t('typography.privacyPolicy')}
    </a>
  )
})

export const agreementField = (label: ReactNode) => ({
  name: 'agreement',
  checkboxLabel: <span className={styles.checkboxLabel}>{label}</span>,
  type: 'checkbox' as FieldType
})

export const marketingConsentField = (t: TFunction) => ({
  name: 'marketingConsent',
  checkboxLabel: (
    <span className={`${styles.checkboxLabel} ${styles.marketingConsent}`}>
      {t('typography.marketingConsentStart')}{' '}
      <button type="button" className={styles.tooltipTrigger}>
        <Tooltip content={t('typography.marketingConsentDetail')}>
          {t('typography.marketingConsentTooltipTrigger')}
        </Tooltip>
      </button>{' '}
      {t('typography.marketingConsentEnd')}
    </span>
  ),
  type: 'checkbox' as FieldType
})
